export default function getMeetingTitle(index: number) {
  return index === 0 ? 'Initial Evaluation' : `Progress Note #${index}`;
}
